<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getPageThemeColor } from '@/utils/modules/getStyles'
import { changeNumToZhCn, textLenHandler, filtersRichtext } from '@/utils/common'

export default {
  name: 'Comp27',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getPageThemeColor, changeNumToZhCn, textLenHandler, filtersRichtext,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    },
    getModuleColor(idx) {
      let arr = []
      switch (idx) {
        case 0: arr = ['#53C2F1', '#E9F5FD']
          break
        case 1: arr = ['#EEE337', '#FFFDED']
          break
        case 2: arr = ['#EF8200', '#FDECE3']
          break
        case 3: arr = ['#E50012', '#FADAD9']
          break
      }
      return arr
    }
  }
}
</script>

<template>
  <div class="modules-id-27">
    <module-title :title="moduleOption.title" margin-bottom="25" />
    <div class="comp-transverse-2 modules-id-27-content pointer">
      <div class="title-content" @click="onModuleItem(moduleOption.list[0])">
        <p v-if="moduleOption.list[0] && moduleOption.list[0].headline" class="title-text" :style="{backgroundColor: getPageThemeColor(path)}">
          {{ moduleOption.list[0].headline | textLenHandler(18) }}
        </p>
        <p v-if="moduleOption.list[0] && moduleOption.list[0].memo" class="content-text h-line-2">
          {{ moduleOption.list[0].memo | filtersRichtext }}
        </p>
      </div>
      <div class="group-content">
        <div
          v-for="(v, i) in moduleOption.list.slice(1, 5)"
          :key="`modules-27-${v.id}`"
          :style="{boxShadow: `0 3px 10px 0 ${getPageThemeColor(path, 0.1)}`}"
          class="group-content-item"
          @click="onModuleItem(v)"
        >
          <p class="item-left-title" :style="{backgroundColor: getModuleColor(i)[0]}">
            {{ `(${changeNumToZhCn(i + 1)})` }}{{ textLenHandler(v.headline, 6, 1) }}
          </p>
          <div class="item-right" :style="{backgroundColor: getModuleColor(i)[1]}">
            <p class="item-right-memo h-line-3">{{ filtersRichtext(v.memo) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-27-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.title-content {
  width: 706px;
  .title-text {
    min-width: 134px;
    height: 36px;
    border-radius: 5px;
    font-size: 17px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 36px;
    padding: 0 25px;
    box-sizing: border-box;
    display: inline-block;
  }
  .content-text {
    width: 706px;
    font-size: 15px;
    font-weight: 600;
    color: #000;
    line-height: 22px;
    margin-top: 18px;
  }
}

.group-content {
  width: 706px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 26px;
  row-gap: 25px;
  margin-top: 27px;
}
.group-content-item {
  width: 340px;
  height: 91px;
  border-radius: 5px;
  display: flex;
  .item-left-title {
    width: 67px;
    height: 91px;
    padding: 8px 15px 0;
    border-radius: 5px;
    text-align: center;
    box-sizing: border-box;
    font-size: 15px;
    font-weight: bold;
    color: #fff;
  }
  .item-right {
    width: 273px;
    height: 91px;
    padding: 14px 18px;
    box-sizing: border-box;
    .item-right-memo {
      font-size: 15px;
      font-weight: 600;
      color: #000;
      line-height: 22px;
      width: 240px;
    }
  }
}
</style>
